<template>
  <div class="wrap">
    <div
      ref="media"
      class="media"
    >
      <div
        v-show="!initialized"
        @click="play"
        class="video-overlay"
        :style="{
          'background-image': `url('${require('@/assets/images/thumbnail.jpg')}')`
        }"
      >
        <figure class="circle">
          <img
            alt=""
            draggable="false"
            :src="require('@/assets/images/play-overlay.svg')"
            class="play-overlay"
          />
        </figure>
      </div>
      <video
        v-if="reached && inView"
        class="video"
        ref="video"
        :src="require('@/assets/videos/elections.mp4')"
        controls
        playsinline
        preload="metadata"
      >
        <p>Your browser doesn't support HTML5 video.</p>
      </video>
      <div v-else class="placeholder"></div>
    </div>
    <p class="source">Bron: Nederlands Instituut voor Beeld en Geluid</p>
  </div>
</template>

<script>
import { trekVideo } from '@/utils/trek'
import { scrollPositionMixin } from '@/mixins'

export default {
  name: 'ElectionsVideo',
  data () {
    return {
      track: 'video-elections',
      initialized: false,
      paused: true
    }
  },
  methods: {
    play () {
      this.initialized = true

      if (this.$refs.video) {
        this.$refs.video.play()
        trekVideo(this.track)
      }
    },
    pause () {
      this.$refs.video.pause()
    }
  },
  mixins: [scrollPositionMixin]
}
</script>

<style lang="scss" scoped>
.wrap {
  margin: 40px 0;

  @media (min-width: 768px) {
    margin: 80px 0;
  }
}

.media {
  position: relative;
  z-index: 1;
  font-size: 0;
}

.video-overlay {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.circle {
  border-radius: 50%;
  position: absolute;
  text-align: center;
  z-index: 2;
  width: 56px;
  height: 56px;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  transform: translateY(-50%);
  background-color: #E61E14;
  animation: pulse 2s infinite;
}

.play-overlay {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
}

.video {
  width: 100%;
  height: auto;
  outline: 0;
  background-color: white;
}

.source {
  margin: 0.5em auto 0;
  font-style: italic;
  font-size: 14px;
}

.placeholder {
  width: 100%;
  height: 0;
  padding-bottom: 56.269%;
}
</style>
